import {
    Component,
    Host,
    h,
    Element,
    Event,
    EventEmitter,
} from "@stencil/core";
import applyElementPolyfills from "../../../polyfills/element";
import "../../../polyfills/node-list";

applyElementPolyfills();

@Component({
    tag: "ux-iws-navigation-meta",
    styleUrl: "navigation-meta.scss",
    shadow: false,
})
export class MetaNavigation {
    private baseClass = "ux-iws-navigation-meta";
    private interval: any;

    @Element() metaEl: HTMLUxIwsNavigationMetaElement;

    componentDidLoad() {
        const search = this.metaEl.querySelectorAll(
            `.${this.baseClass}__search`
        ) as NodeListOf<Element>;

        if (search !== null) {
            search.forEach((element) => {
                element.addEventListener("click", (e) => this.toggleSearch(e));
                element.addEventListener("focus", (e) => {
                    this.toggleSearch(e);
                });
            });
        }

        const subMenus = this.metaEl.querySelectorAll(
            `.ux-iws-header__meta-container-dropdown .${this.baseClass}__item a`
        ) as NodeListOf<Element>;

        this.interval = setInterval(() => {
            const profileLink = this.metaEl.querySelector(
                "a[name='profile']"
            ) as HTMLAnchorElement;

            if (profileLink !== null) {
                clearInterval(this.interval);
                profileLink.addEventListener("click", (e) => {
                    e.preventDefault();
                });
            }
        }, 500);

        subMenus.forEach((subMenu) => {
            if (subMenu.hasAttribute("data-sub-target")) {
                subMenu.addEventListener("click", (e) =>
                    this.toggleSubMenu(
                        e,
                        subMenu.getAttribute("data-sub-target")
                    )
                );
            }
        });

        const closeSubMenuButton = this.metaEl.querySelector(
            `.ux-iws-navigation-meta__sub-menu-close`
        ) as HTMLElement;

        if (closeSubMenuButton !== null) {
            closeSubMenuButton.addEventListener("click", () => {
                const subMenu = this.metaEl.querySelector(
                    `.${this.baseClass}__sub-menu-container`
                ) as HTMLElement;
                subMenu.classList.remove(
                    `${this.baseClass}__sub-menu-container--active`
                );
            });
        }
    }

    private toggleSubMenu(event, target) {
        event.preventDefault();
        const subMenu = this.metaEl.querySelector(
            `.${this.baseClass}__sub-menu-container`
        ) as HTMLElement;
        subMenu.classList.add(`${this.baseClass}__sub-menu-container--active`);

        const subMenuContent = this.metaEl.querySelector(
            `.${this.baseClass}__sub-menu[data-sub-menu="${target}"]`
        ) as HTMLElement;
        subMenuContent.classList.add(`${this.baseClass}__sub-menu--active`);
    }

    private toggleSearch(event) {
        const parentContainer = event.target.closest(
            `.${this.baseClass}__search`
        );

        if (
            !parentContainer.classList.contains(
                `${this.baseClass}__search--open`
            )
        ) {
            parentContainer.classList.add(`${this.baseClass}__search--open`);
            const input = parentContainer.querySelector(`input`);

            if (input) {
                input.focus();
            }
        } else if (
            event.target.classList.contains(
                "ux-iws-navigation-meta__search__close"
            )
        ) {
            parentContainer.classList.remove(`${this.baseClass}__search--open`);
        }

        // Close burger menu
        const burgerMenu =
            document.querySelector<HTMLUxIwsNavBurgerElement>(
                "ux-iws-nav-burger"
            );
        if (burgerMenu !== null) {
            burgerMenu.close();
        }
    }

    private handleLocaleSelectionClick = (e: Event) => {
        const eTarget = e.target as HTMLElement;
        const dataNavigationAttribute = "data-meta-navigation";
        const changeLocaleValue = "locale-selection";
        if (
            eTarget.closest("a")?.getAttribute(dataNavigationAttribute) ===
                changeLocaleValue ||
            eTarget.getAttribute(dataNavigationAttribute) === changeLocaleValue
        ) {
            e.preventDefault();
            this.navigationLocaleSelectionOpen.emit({ isOpen: true });
        }
    };

    /** event emitted when the locale selection link is clicked */
    @Event({
        eventName: "uxNavigationLocaleSelection",
        composed: true,
        cancelable: true,
        bubbles: true,
    })
    navigationLocaleSelectionOpen: EventEmitter<{ isOpen: boolean }>;

    render() {
        const { baseClass } = this;
        return (
            <Host class={baseClass} onClick={this.handleLocaleSelectionClick}>
                <slot />
            </Host>
        );
    }
}
